<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 搜索条件区域 -->
        <div class="table-page-search-wrapper" :class="{ 'is-collapsed': !advanced }">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <!-- 基础搜索条件 -->
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="信标MAC" prop="mac">
                  <a-input
                    v-model:value="queryParam.mac"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="设备码" prop="deviceCode">
                  <a-input
                    v-model:value="queryParam.deviceCode"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="Major" prop="major">
                  <a-input
                    v-model:value="queryParam.major"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <span class="search-actions-group">
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </span>
                </a-form-item>
              </a-col>

              <!-- 高级搜索条件（展开后显示） -->
              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="Minor" prop="minor">
                    <a-input
                      v-model:value="queryParam.minor"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="启用时间" prop="activationBeginTime">
                    <a-range-picker
                      style="width: 100%"
                      v-model:value="activationTimeRange"
                      :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="续航时间(天)" prop="batteryLife">-->
                <!--                  <a-input-number-->
                <!--                    v-model:value="queryParam.batteryLife"-->
                <!--                    :min="0"-->
                <!--                    style="width: 100%"-->
                <!--                    placeholder="请输入"-->
                <!--                    class="no-border-radius-input-number"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="电池更换时间" prop="batteryReplacementBeginTime" :colon="false">
                    <a-range-picker
                      style="width: 100%"
                      v-model:value="batteryReplacementTimeRange"
                      :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="信标状态" prop="beaconStatus">
                    <a-select
                      v-model:value="queryParam.beaconStatus"
                      placeholder="请选择"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['beacon_status']"
                        :key="d.value"
                        :value="d.value"
                        >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="最新状态时间" prop="beaconTime" :colon="false">-->
                <!--                  <a-date-picker-->
                <!--                    style="width: 100%"-->
                <!--                    v-model:value="queryParam.beaconTime"-->
                <!--                    :show-time="{ format: 'HH:mm:ss' }"-->
                <!--                    valueFormat="YYYY-MM-DD HH:mm:ss"-->
                <!--                    format="YYYY-MM-DD HH:mm:ss"-->
                <!--                    allow-clear-->
                <!--                    class="no-border-radius-picker"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="所属空间" prop="spaceName">
                    <a-input
                      v-model:value="queryParam.spaceName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="绑定空间时间" prop="bindBeginTime" :colon="false">
                    <a-range-picker
                      style="width: 100%"
                      v-model:value="bindTimeRange"
                      :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <span class="search-actions-group">
                        <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                        <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                          {{ advanced ? '收起' : '展开' }}
                          <UpOutlined v-if="advanced" />
                          <DownOutlined v-else />
                        </a-button>
                      </span>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>

        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="getList"
            v-hasPermi="['system:beacon:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:beacon:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['system:beacon:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            @click="$refs.importExcel.importExcelHandleOpen()"
            v-hasPermi="['system:beacon:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:beacon:remove']"
            class="no-border-button delete-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:beacon:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
          <!-- <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
        </div>

        <!-- 导入Excel组件 -->
        <import-excel ref="importExcel" @ok="getList" />

        <!-- 新增/编辑表单组件 -->
        <create-form ref="createForm" @ok="getList" @close="getList" />

        <!-- 信标日志组件 -->
        <beacon-log
          :visible="beaconLogModalVisible"
          :beaconId="currentBeaconId"
          :beaconName="currentBeaconName"
          permissionPrefix="system:beaconLog"
          @close="handleCloseBeaconLog"
        />

        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 'max-content' }"
            class="optimized-table"
          >
            <!-- 使用 bodyCell 插槽自定义单元格显示 -->
            <template #bodyCell="{ column, text }">
              <!-- 信标状态：使用字典标签显示 -->
              <template v-if="column.dataIndex === 'beaconStatus'">
                <span>
                  <dict-tag
                    v-if="dict.type && dict.type['beacon_status'] && dict.type['beacon_status'].length > 0"
                    :options="dict.type['beacon_status']"
                    :value="text"
                  />
                  <span v-else>{{ text || '-' }}</span>
                </span>
              </template>
            </template>
            <!-- 时间格式化显示 -->
            <template v-slot:bindTime="text, record">
              <span>
                {{ parseTime(record.bindTime) }}
              </span>
            </template>
            <template v-slot:activationTime="text, record">
              <span>
                {{ parseTime(record.activationTime) }}
              </span>
            </template>
            <template v-slot:batteryReplacement="text, record">
              <span>
                {{ parseTime(record.batteryReplacement) }}
              </span>
            </template>
            <template v-slot:beaconTime="text, record">
              <span>
                {{ parseTime(record.beaconTime) }}
              </span>
            </template>
            <template v-slot:createTime="text, record">
              <span>
                {{ parseTime(record.createTime) }}
              </span>
            </template>

            <!-- 操作列 -->
            <template #operation="{ record }">
              <div class="table-action-buttons">
                <a
                  @click="$refs.createForm.handleUpdate(record, undefined)"
                  v-hasPermi="['system:beacon:edit']"
                  class="edit-link"
                >
                  编辑
                </a>
                <span class="action-divider">|</span>
                <a
                  @click="handleViewBeaconLog(record)"
                  v-hasPermi="['system:beacon:beaconLog']"
                  class="beacon-log-link"
                >
                  信标日志
                </a>
              </div>
            </template>
          </a-table>
        </div>

        <!-- 分页组件 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
/**
 * 信标管理页面
 * 功能：信标的查询、新增、编辑、删除、导入、导出、启用/禁用等操作
 */
import { pageBeacon, delBeacon, changeBeaconStatus } from '@/api/system/beacon'
import {
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import BeaconLog from './modules/BeaconLog'
import { tableMixin } from '@/store/table-mixin'
import storage from 'store'

export default {
  name: 'Beacon',
  components: {
    CreateForm,
    ImportExcel,
    BeaconLog,
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    DownloadOutlined,
    UploadOutlined,
    DeleteOutlined,
    CloudDownloadOutlined,
  },
  // 字典类型配置
  dicts: ['beacon_status'],
  mixins: [tableMixin],
  data() {
    return {
      // 表格数据列表
      list: [],
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 高级搜索展开/收起状态
      advanced: false,
      // 非单个禁用（用于批量操作按钮）
      single: true,
      // 非多个禁用（用于批量操作按钮）
      multiple: true,
      // 选中的ID数组（用于删除等操作）
      ids: [],
      // 表格加载状态
      loading: false,
      // 数据总数
      total: 0,
      // 信标日志弹窗
      beaconLogModalVisible: false,
      currentBeaconId: null,
      currentBeaconName: '',
      // 分页跳转
      jumpPage: 1,
      // 查询参数对象
      queryParam: {
        projectId: null, // 项目ID
        mac: null, // 信标MAC地址
        deviceCode: null, // 设备码
        major: null, // Major参数
        minor: null, // Minor参数
        activationBeginTime: undefined, // 启用开始时间
        activationEndTime: undefined, // 启用结束时间
        batteryLife: null, // 续航时间(天)
        batteryReplacementBeginTime: undefined, // 电池更换开始时间 yyyy-MM-dd 00:00:00
        batteryReplacementEndTime: undefined, // 电池更换结束时间 yyyy-MM-dd 23:59:59
        beaconStatus: undefined, // 信标状态
        beaconTime: null, // 最新状态时间
        spaceName: null, // 所属空间
        bindBeginTime: undefined, // 绑定空间开始时间
        bindEndTime: undefined, // 绑定空间结束时间
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页显示数量
      },
      // 表格列配置（序号列移到 computed 中）
      columns: [
        {
          title: '信标MAC',
          dataIndex: 'mac',
          align: 'center',
        },
        {
          title: '设备码',
          dataIndex: 'deviceCode',
          align: 'center',
        },
        {
          title: 'Major',
          dataIndex: 'major',
          align: 'center',
        },
        {
          title: 'Minor',
          dataIndex: 'minor',
          align: 'center',
        },
        {
          title: '启用时间',
          dataIndex: 'activationTime',
          scopedSlots: { customRender: 'activationTime' },
          align: 'center',
        },
        {
          title: '续航时间(天)',
          dataIndex: 'batteryLife',
          align: 'center',
        },
        {
          title: '电池更换时间',
          dataIndex: 'batteryReplacement',
          scopedSlots: { customRender: 'batteryReplacement' },
          align: 'center',
        },
        {
          title: '信标状态',
          dataIndex: 'beaconStatus',
          align: 'center',
        },
        {
          title: '最新状态时间',
          dataIndex: 'beaconTime',
          scopedSlots: { customRender: 'beaconTime' },
          align: 'center',
        },
        {
          title: '所属空间',
          dataIndex: 'spaceName',
          align: 'center',
        },
        {
          title: '绑定空间时间',
          dataIndex: 'bindTime',
          scopedSlots: { customRender: 'bindTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          slots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  computed: {
    activationTimeRange: {
      get() {
        const begin = this.queryParam.activationBeginTime
        const end = this.queryParam.activationEndTime
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.activationBeginTime = begin || undefined
        this.queryParam.activationEndTime = end || undefined
      },
    },
    bindTimeRange: {
      get() {
        const begin = this.queryParam.bindBeginTime
        const end = this.queryParam.bindEndTime
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.bindBeginTime = begin || undefined
        this.queryParam.bindEndTime = end || undefined
      },
    },
    batteryReplacementTimeRange: {
      get() {
        const begin = this.queryParam.batteryReplacementBeginTime
        const end = this.queryParam.batteryReplacementEndTime
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const toStr = (v) => {
          if (v == null) return null
          if (typeof v === 'string') return v
          if (typeof v === 'object' && typeof v.format === 'function') return v.format('YYYY-MM-DD HH:mm:ss')
          return String(v)
        }
        const beginRaw = Array.isArray(val) && val.length > 0 ? val[0] : null
        const endRaw = Array.isArray(val) && val.length > 1 ? val[1] : null
        const beginStr = toStr(beginRaw)
        const endStr = toStr(endRaw)
        this.queryParam.batteryReplacementBeginTime = beginStr
          ? (beginStr.split(' ')[0] || beginStr) + ' 00:00:00'
          : undefined
        this.queryParam.batteryReplacementEndTime = endStr ? (endStr.split(' ')[0] || endStr) + ' 23:59:59' : undefined
      },
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'id',
          width: 80,
          align: 'center',
          customRender: ({ index }) => {
            const pageNum = that.queryParam.pageNum || 1
            const pageSize = that.queryParam.pageSize || 10
            const currentIndex = index !== undefined && index !== null ? Number(index) : 0
            if (isNaN(currentIndex) || isNaN(pageNum) || isNaN(pageSize)) {
              return currentIndex + 1
            }
            return (pageNum - 1) * pageSize + currentIndex + 1
          },
        },
        ...this.columns, // 包含所有列配置，包括信标MAC
      ]
    },
    submitButtonStyle() {
      return {}
    },
  },
  watch: {
    '$store.getters.currentProjectId'(projectId, prevProjectId) {
      if (projectId == prevProjectId) {
        return
      }
      this.handleProjectChanged(projectId)
    },
  },
  created() {
    this.syncProjectId()
    this.getList()
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    // 移除事件监听
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  methods: {
    /**
     * 同步顶部「当前项目」到查询参数。刷新后 Vuex 可能尚未恢复，需回退本地存储。
     */
    syncProjectId() {
      const currentProjectId =
        this.$store.getters.currentProjectId || storage.get('currentProjectId')
      this.queryParam.projectId = currentProjectId || undefined
      return this.queryParam.projectId
    },
    /**
     * 查询信标列表
     * 必须带上当前项目ID，否则后台会查出权限范围内其他项目的数据
     */
    getList() {
      const currentProjectId = this.syncProjectId()
      if (!currentProjectId) {
        this.list = []
        this.total = 0
        this.loading = false
        return
      }
      this.loading = true
      const params = {
        ...this.queryParam,
        projectId: currentProjectId,
        batteryReplacementBeginTime: this.queryParam.batteryReplacementBeginTime || undefined,
        batteryReplacementEndTime: this.queryParam.batteryReplacementEndTime || undefined,
      }
      pageBeacon(params)
        .then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.jumpPage = this.queryParam.pageNum
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /**
     * 处理项目变化事件
     * 当右侧项目选择发生变化时，更新查询参数并刷新列表
     * @param {Number} projectId - 新选中的项目ID（可能为 undefined，表示清空选择）
     */
    handleProjectChanged(projectId) {
      this.queryParam.projectId = projectId || storage.get('currentProjectId') || undefined
      this.queryParam.pageNum = 1
      this.getList()
    },

    /**
     * 搜索按钮操作
     * 重置页码为第一页，然后查询数据
     */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /**
     * 重置按钮操作
     * 清空所有查询条件，保留项目ID（从Vuex获取）和分页参数
     */
    resetQuery() {
      this.syncProjectId()
      const currentProjectId = this.queryParam.projectId
      this.queryParam = {
        projectId: currentProjectId || undefined, // 项目ID（从Vuex获取）
        mac: undefined, // 信标MAC地址
        deviceCode: undefined, // 设备码
        major: undefined, // Major参数
        minor: undefined, // Minor参数
        activationBeginTime: undefined, // 启用开始时间
        activationEndTime: undefined, // 启用结束时间
        batteryLife: undefined, // 续航时间(天)
        batteryReplacementBeginTime: undefined, // 电池更换开始时间
        batteryReplacementEndTime: undefined, // 电池更换结束时间
        beaconStatus: undefined, // 信标状态
        beaconTime: undefined, // 最新状态时间
        spaceName: undefined, // 所属空间
        bindBeginTime: undefined, // 绑定空间开始时间
        bindEndTime: undefined, // 绑定空间结束时间
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页显示数量
      }
      this.handleQuery()
    },

    /**
     * 分页大小改变事件
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页显示数量
     */
    onShowSizeChange(current, pageSize) {
      if (this.loading) return
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 分页改变事件
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页显示数量
     */
    changeSize(current, pageSize) {
      if (this.loading) return
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },

    /**
     * 表格行选择改变事件
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    /**
     * 切换高级搜索展开/收起状态
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 删除按钮操作
     * @param {Object} row - 行数据对象，如果为空则删除选中的多条数据
     */
    handleDelete(row) {
      const that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      // 获取要删除的信标MAC地址
      let macText = ''
      if (row && row.mac) {
        // 单行删除，显示该行的MAC
        macText = row.mac
      } else if (this.selectedRows && this.selectedRows.length > 0) {
        // 多行删除，显示所有选中行的MAC
        const macs = this.selectedRows.map((item) => item.mac).filter((mac) => mac)
        macText = macs.join('、')
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: macText ? `删除信标MAC为 ${macText} 的数据` : '确认删除所选数据?',
        onOk() {
          const data = that.ids.map((id) => ({ id }))
          return delBeacon(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          // 取消时清空删除ids列表
          that.ids = []
        },
      })
    },

    /**
     * 下载导入模板
     */
    handleDownloadTemplate() {
      this.download('system/beacon/importTemplate', {}, `信标导入模板_${new Date().getTime()}.xls`)
    },

    /**
     * 导出按钮操作
     * 支持导出选中数据或全部数据
     */
    handleExport() {
      const params = { ...this.queryParam }
      const hasSelection = this.selectedRowKeys && this.selectedRowKeys.length > 0
      if (hasSelection) {
        params.beaconIds = this.selectedRowKeys
      }
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk: () => {
          this.download('system/beacon/export', params, `信标_${new Date().getTime()}.xls`)
        },
      })
    },

    /**
     * 启用按钮操作
     */
    handleEnable() {
      this.handleChangeStatus(1)
    },

    /**
     * 禁用按钮操作
     */
    handleDisable() {
      this.handleChangeStatus(0)
    },

    /**
     * 批量修改状态（启用/禁用）
     * @param {Number} status - 状态值，1-启用，0-禁用
     */
    handleChangeStatus(status) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要操作的数据')
        return
      }
      const actionText = status === 1 ? '启用' : '禁用'
      const ids = [...this.selectedRowKeys].join(',')
      this.$confirm({
        title: `确认${actionText}所选中数据?`,
        content: `当前选中编号为 ${ids} 的数据`,
        onOk: () => {
          const data = {
            ids,
            status: status,
          }
          return changeBeaconStatus(data).then(() => {
            this.$message.success(`${actionText}成功`)
            this.onSelectChange([], [])
            this.getList()
          })
        },
      })
    },

    /**
     * 查看信标日志
     * @param {Object} record - 行数据对象
     */
    handleViewBeaconLog(record) {
      if (!record || !record.id) {
        this.$message.warning('信标信息不完整', 3)
        return
      }
      this.currentBeaconId = record.id
      this.currentBeaconName = record.mac || '未知信标'
      this.beaconLogModalVisible = true
    },

    /**
     * 关闭信标日志弹窗
     */
    handleCloseBeaconLog() {
      this.beaconLogModalVisible = false
      this.currentBeaconId = null
      this.currentBeaconName = ''
    },

    /**
     * 分页跳转
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px !important;
  max-width: 80px !important;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
}

.table-page-search-wrapper :deep(.ant-form-item) {
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-row) {
  flex-wrap: nowrap;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 0 !important;
  max-width: none !important;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper.is-collapsed :deep(.ant-form-item-control-input .ant-input) {
  max-width: none !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper.is-collapsed :deep(.ant-input-affix-wrapper) {
  max-width: none !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: 0;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper.is-collapsed :deep(.ant-picker) {
  max-width: none !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper.is-collapsed :deep(.ant-select-selector) {
  max-width: none !important;
}

.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  max-width: 260px;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper.is-collapsed :deep(.ant-select) {
  max-width: none !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索区域数字输入框样式 - 续航时间(天) */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择器确定按钮样式 */
:deep(.ant-picker-ok-btn),
:deep(.ant-picker-footer .ant-btn-primary),
:deep(.ant-picker-footer .ant-btn-primary.ant-btn) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-picker-ok-btn:hover),
:deep(.ant-picker-ok-btn:focus),
:deep(.ant-picker-footer .ant-btn-primary:hover),
:deep(.ant-picker-footer .ant-btn-primary:focus),
:deep(.ant-picker-footer .ant-btn-primary.ant-btn:hover),
:deep(.ant-picker-footer .ant-btn-primary.ant-btn:focus) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-picker-ok-btn:active),
:deep(.ant-picker-footer .ant-btn-primary:active),
:deep(.ant-picker-footer .ant-btn-primary.ant-btn:active) {
  background-color: #0e4acc !important;
  border-color: #0e4acc !important;
  color: #ffffff !important;
}

/* 数字输入框聚焦样式 - 保持边框，不高亮 */
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number:focus),
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number-focused),
.table-page-search-wrapper :deep(.ant-input-number:focus),
.table-page-search-wrapper :deep(.ant-input-number-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 数字输入框内部input聚焦样式 - 隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number:focus .ant-input-number-input),
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number-focused .ant-input-number-input),
.table-page-search-wrapper :deep(.ant-input-number:focus .ant-input-number-input),
.table-page-search-wrapper :deep(.ant-input-number-focused .ant-input-number-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

.search-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item-row) {
    flex-wrap: wrap;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto !important;
    max-width: none !important;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    flex: 1 1 100% !important;
    max-width: none !important;
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}
.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 信标日志按钮样式 */
.table-action-buttons .beacon-log-link {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.table-action-buttons .beacon-log-link:hover {
  color: #333333 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 删除按钮样式 - 参照 projectUser 页面的修改状态按钮 */
.delete-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.delete-button:hover,
.delete-button:focus {
  color: #333333 !important;
}

.delete-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 导入导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover,
.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover :deep(.anticon),
.import-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}
</style>

<style>
/* 日期选择器确定按钮全局样式 - 因为弹出层挂载在 body 上 */
.ant-picker-ok-btn,
.ant-picker-footer .ant-btn-primary,
.ant-picker-footer .ant-btn-primary.ant-btn {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-picker-ok-btn:hover,
.ant-picker-ok-btn:focus,
.ant-picker-footer .ant-btn-primary:hover,
.ant-picker-footer .ant-btn-primary:focus,
.ant-picker-footer .ant-btn-primary.ant-btn:hover,
.ant-picker-footer .ant-btn-primary.ant-btn:focus {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-picker-ok-btn:active,
.ant-picker-footer .ant-btn-primary:active,
.ant-picker-footer .ant-btn-primary.ant-btn:active {
  background-color: #0e4acc !important;
  border-color: #0e4acc !important;
  color: #ffffff !important;
}
</style>
